'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (feis_id, pageSource) {
  return function (dispatch) {
    dispatch({
      feis_id: feis_id,
      pageSource: pageSource,

      type: 'SET_PREVIOUS_STEWARDING_STAGE_PAGE_SOURCE'
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/setCurrentPageSourceForStageStewarding.js
// module id = 246
// module chunks = 0